import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=1d2b6a64"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d2b6a64')) {
      api.createRecord('1d2b6a64', component.options)
    } else {
      api.reload('1d2b6a64', component.options)
    }
    module.hot.accept("./Activity.vue?vue&type=template&id=1d2b6a64", function () {
      api.rerender('1d2b6a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/Activity.vue"
export default component.exports